// redux/user/userThunks.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  changeUserStatus,
  deleteUser,
  fetchUsers,
  getUserById,
  updateUser,
  deleteUserAll,
  addAdminNote,
  getUserActivityLog,
} from "../../components/services/userService";
import { handleUnauthorized } from "../../utils/apiHelper";

export const fetchUserById = createAsyncThunk(
  "user/fetchById",
  async ({ id, navigate }, { rejectWithValue }) => {
    try {
      const { data } = await getUserById(id);
      return data.user;
    } catch (err) {
      if (err.response?.status === 401) {
        handleUnauthorized(navigate);
      }
      return rejectWithValue(err.message || "Failed to fetch user");
    }
  }
);

// Fetch all users with optional filters
export const fetchAllUsers = createAsyncThunk(
  "user/fetchUsersList",
  async ({ params, navigate }, { getState, rejectWithValue }) => {
    try {
      const { filters } = getState().user;
      const mergedParams = { ...filters, ...params }; 
      const { data } = await fetchUsers(mergedParams);
      return data;
    } catch (err) {
      if (err.response?.status === 401) handleUnauthorized(navigate);
      return rejectWithValue(err.message || "Failed to fetch users");
    }
  }
);

// Update user by ID
export const updateUserById = createAsyncThunk(
  "user/update",
  async ({ id, data, navigate }, { rejectWithValue }) => {
    try {
      const res = await updateUser(id, data);
      return res.data.user;
    } catch (err) {
      if (err.response?.status === 401) handleUnauthorized(navigate);
      return rejectWithValue(err.message || "Failed to update user");
    }
  }
);

// Change status (ban/unban)
export const toggleUserStatus = createAsyncThunk(
  "user/changeStatus",
  async ({ id, data, navigate }, { rejectWithValue }) => {
    try {
      const res = await changeUserStatus(id, data);
      return { id, status: res.data.status,}; // Return updated status and ID
    } catch (err) {
      if (err.response?.status === 401) handleUnauthorized(navigate);
      return rejectWithValue(err.message || "Failed to change status");
    }
  }
);

// Delete user
export const deleteUserById = createAsyncThunk(
  "user/delete",
  async ({ id, navigate }, { rejectWithValue }) => {
    try {
      await deleteUser(id);
     return id 
   
    } catch (err) {
      if (err.response?.status === 401) handleUnauthorized(navigate);
      return rejectWithValue(err.message || "Failed to delete user");
    }
  }
);


// Delete all user
export const deleteUserAlls = createAsyncThunk(
  "user/deleteall",
  async ({ id, navigate }, { rejectWithValue }) => {
    try {
      const response = await deleteUserAll(id);
     return response 
   
    } catch (err) {
      if (err.response?.status === 401) handleUnauthorized(navigate);
      return rejectWithValue(err.message || "Failed to delete user");
    }
  }
);

// Add admin note
export const addAdminNotes = createAsyncThunk(
  "user/adminnote",
  async ({ id,note, navigate }, { rejectWithValue }) => {
    try {
      const response = await addAdminNote(id,note);
     return response 
   
    } catch (err) {
      if (err.response?.status === 401) handleUnauthorized(navigate);
      return rejectWithValue(err.message || "Failed to delete user");
    }
  }
);


export const fetchUserActivityLogs = createAsyncThunk(
  "user/fetchActivityLogs",
  async (userId, { rejectWithValue }) => {
    try {
      console.log(userId,'userId')
      const response = await getUserActivityLog(userId);
      return response?.data?.data; // assuming API returns { status, data: [...] }
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);